import { useEffect, useState } from 'react';
import { Alert, AlertTitle, IconButton, Slide, useTheme, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';

const SlideLeft = (props: any) => <Slide {...props} direction="right" />;

export default function ConnectionStatus() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const [show, setShow] = useState<boolean>(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShow(true);
      setTimeout(() => setShow(false), 4000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShow(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <SlideLeft in={show} mountOnEnter unmountOnExit>
      <Alert
        icon={isOnline ? <WifiIcon /> : <WifiOffIcon />}
        severity={isOnline ? 'success' : 'error'}
        action={
          <IconButton
            aria-label="fechar"
            color="inherit"
            size="small"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        sx={{
          position: 'fixed',
          bottom: 16,
          left: 16,
          width: isMobile ? '90%' : '360px',
          zIndex: 1300,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <AlertTitle>{isOnline ? 'Online' : 'Offline'}</AlertTitle>
        {isOnline ? 'Internet restabelecida.' : 'Sem conexão com a internet.'}
      </Alert>
    </SlideLeft>
  );
}
